import {da, enGB, nb, sv, type Locale} from "date-fns/locale";

const DATE_LOCALES: Record<string, Locale> = {nb, no: nb, da, sv, en: enGB};

/** date-fns locale for an i18n language code ("nb", "en-GB", ...). */
export function getDateLocale(lang: string): Locale {
    return DATE_LOCALES[lang.split("-")[0]] ?? nb;
}
